<app-button
    *ngIf="hasPermissionAndAccess()"
    [styles]="'primary'"
    [text]= "'wizard.newCampaign' | translate"
    (output)="openWizard()"
></app-button>
